/*
 * @Descripttion: AI 模型配置列表
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2026-10-29 10:00:00
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Modal, notification } from 'antd'
import React, { ReactElement, useContext, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { RootDispatch } from '../../app/store'
import { EditableList } from '../../compnents/list/EditableList'
import { ThemeContext } from '../../theme/ThemeContext'
import styles from './ModelList.module.css'
import { ModelColumns } from './ModelColumns'
import { enableAIModelAsync, getAIModelPageAsync } from './ModelListSlice'

interface modelListProps {
  visible: boolean
  onCancel: () => void
}

export const ModelList = ({
  visible,
  onCancel,
}: modelListProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [pageLoading, setPageLoading] = useState(false)

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [params, setParams] = useState<any>({
    current: 1,
    size: 10,
  })

  const getPage = (query: any) => {
    setPageLoading(true)
    dispatch(getAIModelPageAsync({ ...query }))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          items: res?.records || [],
          total: res?.total || 0,
        })
        setPageLoading(false)
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (visible) {
      getPage(params)
    }
  }, [visible, params])

  /** 启用 / 停用 */
  const toggleEnable = (record: any, checked: boolean) => {
    dispatch(
      enableAIModelAsync({
        id: record?.id,
        isEnable: checked ? 1 : 0,
      })
    )
      .then(unwrapResult)
      .then(() => {
        notification.success({
          message: '操作成功',
          duration: 3,
        })
        getPage(params)
      })
      .catch(() => {
        // 失败时重新拉取列表，还原开关状态（错误提示已由全局统一弹出）
        getPage(params)
      })
  }

  return (
    <>
      <Modal
        title='模型配置'
        width={1200}
        visible={visible}
        onCancel={() => onCancel()}
        centered
        footer={null}
        className={styles.editRemark}
        maskStyle={{
          overflow: 'hidden',
        }}
      >
        <div className={styles.body} style={{ backgroundColor: theme.pn }}>
          <EditableList
            className={styles.table}
            loading={pageLoading}
            page={{
              current: params.current,
              size: params.size,
              total: page.total,
              items: page.items,
            }}
            columns={ModelColumns(
              {
                onToggleEnable: toggleEnable,
              },
              params.size * (params.current - 1)
            )}
            onChangePage={(current, size) =>
              setParams({
                ...params,
                current,
                size: size || 10,
              })
            }
          />
        </div>
      </Modal>
    </>
  )
}
